import { Table as AntTable, TablePaginationConfig } from 'antd';
import { ExpandableConfig } from 'antd/lib/table/interface';
import React, { useMemo } from 'react';
import { ITableColumn, ITableData } from 'shared/interfaces/utils/ITable';

import { TableWrapper } from './Table.styled';

type Props = {
  columns: ITableColumn[];
  data: ITableData[];
  pagination?: TablePaginationConfig;
  customSize?: string;
  className?: string;
  loading?: boolean;
  rowSelection?: any;
  rowKey?: string;
  style?: React.CSSProperties;
  expandable?: ExpandableConfig<any>;
  // Set false to fit the table to its container instead of scrolling horizontally.
  scrollX?: boolean;
};
const Table: React.FC<Props> = ({
  columns,
  data,
  pagination,
  className,
  rowKey,
  style,
  scrollX = true,
  ...props
}: Props) => {
  const tableColumns = useMemo(() => {
    return columns.map((item: ITableColumn) => {
      if (item === AntTable.EXPAND_COLUMN) {
        return AntTable.EXPAND_COLUMN;
      }

      return {
        title: item.title,
        dataIndex: item.key,
        key: Array.isArray(item.key) ? item.key.join('.') : item.key,
        align: item.align,
        fixed: item.fixed || false,
        ellipsis: item.ellipsis ? item.ellipsis : undefined,
        width: item.width ? item.width : undefined,
        onFilter: item.onFilter ? item.onFilter : undefined,
        sorter: item.sorter ? item.sorter : undefined,
        render: item.render ? item.render : undefined,
        filters: item.filters ? item.filters : undefined,
        filterDropdown: item.filterDropdown ? item.filterDropdown : undefined,
        filterIcon: item.filterIcon ? item.filterIcon : undefined,
        filtered: item.filtered ? item.filtered : undefined,
        filteredValue: item.filteredValue ? item.filteredValue : undefined,
        className: item.className ? item.className : undefined,
      };
    });
  }, [columns]);
  return (
    <TableWrapper>
      <AntTable
        {...props}
        columns={tableColumns}
        className={className}
        dataSource={data}
        pagination={pagination ?? false}
        scroll={scrollX && data?.length > 0 ? { x: 'max-content' } : undefined}
        rowKey={rowKey}
        style={style}
      />
    </TableWrapper>
  );
};

export default Table;
